import {UI} from "../../../../stem-core/src/ui/UIBase";

import {Messages} from "../../../Messages";
import {SocialLoginButtons} from "../../../website/unauthenticated/slides/SocialLoginButtons";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {
    SignUpPasswordlessClass,
    SignUpPasswordlessClassStyle
} from "../../../website/unauthenticated/slides/SignUpPasswordless";
import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {BasePanelPage} from "./BasePanelPage";
import {MerchantButton} from "../../../common/MerchantButton";
import {PoweredByBlink} from "../../PoweredByBlink";
import {TosMessage} from "../../../website/unauthenticated/components/TosMessage";
import {iFrameState} from "../../../services/IFrameState";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../blink-sdk/Constants";
import {panelChildMargin} from "../../../StyleConstants";


class AuthSectionStyle extends SignUpPasswordlessClassStyle {
    @styleRule
    continueLabel = {
        ...this.themeProps.PAYWALL_MESSAGE_STYLE,
        marginTop: panelChildMargin,
        marginBottom: panelChildMargin,
    };

    @styleRuleInherit
    button = {
        margin: "14px 0",
    };

    @styleRuleInherit
    input = {
        marginTop: 0,
    };

    @styleRule
    headerElement = {
        padding: "0 36px",
    };

    @styleRule
    authTitle = this.themeProps.PAYWALL_AUTH_PANEL_TITLE;
}

@registerStyle(AuthSectionStyle)
export class AuthSection extends SignUpPasswordlessClass {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            emailInputLabel: Messages.emailAddress,
            inputPlaceholder: "",
            ButtonClass: MerchantButton,
            showFooterSection: true,
        };
    }

    getHeaderSection() {
        const {styleSheet} = this;
        if (!iFrameState.authSocialProviders.length) {
            return null;
        }

        return [
            Messages.authenticationPanelTitle.toString().trim() ?
                <div className={styleSheet.authTitle}>{Messages.authenticationPanelTitle}</div> : null,
            <div className={styleSheet.continueLabel}>{Messages.continueWithSocial}</div>,
            <SocialLoginButtons className={styleSheet.headerElement} label={""}
                                onButtonClick={(socialAppData) => this.handleSocialLoginButtonClick(socialAppData)}
                                onLoginCallback={() => this.signUpAction()} socialApps={iFrameState.authSocialProviders} />,
            <div className={styleSheet.continueLabel}>{Messages.orContinueWithYourEmailAddress}</div>,
        ];
    }

    getFooterSection() {
        const {showFooterSection} = this.options;
        const extraTosMessageOptions = {};
        if (iFrameMerchantService.isMerchant(TNR_ALIAS)) {
            extraTosMessageOptions.termsLink = "https://newrepublic.com/pages/terms-and-conditions";
            extraTosMessageOptions.policyLink = "https://newrepublic.com/pages/privacy";
        }

        if (showFooterSection) {
            return [
                <TosMessage preMessage={Messages.tosPreMessage} {...extraTosMessageOptions}/>,
                <PoweredByBlink />
            ];
        }
        return null;
    }
}

export class AuthenticationPanel extends BasePanelPage {
    render() {
        return [
            <AuthSection/>
        ];
    }
}
